import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export default class AdminErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message || "Unknown error" };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#161b22] flex items-center justify-center">
          <div className="bg-[#0d1117] rounded-xl border border-gray-700 p-8 max-w-md mx-4 text-center">
            <div className="w-16 h-16 bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-exclamation-triangle text-red-500 text-xl" />
            </div>
            <h2 className="text-lg font-bold text-gray-200 mb-2">Something went wrong</h2>
            <p className="text-sm text-gray-400 mb-4">The admin page encountered an error while loading.</p>
            <details className="text-left mb-5">
              <summary className="text-xs text-gray-400 cursor-pointer hover:text-gray-400">Error details</summary>
              <pre className="mt-2 text-xs text-red-600 bg-red-900/20 p-3 rounded-lg overflow-auto max-h-40">{this.state.errorMessage}</pre>
            </details>
            <button
              onClick={() => {
                this.setState({ hasError: false, errorMessage: "" });
                window.location.reload();
              }}
              className="px-6 py-2.5 bg-[#5cb85c] text-white text-sm font-semibold rounded-lg hover:bg-[#4cae4c] transition-all whitespace-nowrap"
            >
              <i className="fas fa-redo mr-2" />
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}